import { render, staticRenderFns } from "./vpd-alert-dialog.vue?vue&type=template&id=8537b3c6"
import script from "./vpd-alert-dialog.vue?vue&type=script&lang=js"
export * from "./vpd-alert-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports